import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Bridge } from 'src/utils/bridge'
import { useGlobalStore } from 'src/store/zustand'

export function useDisplayLight() {
  const { pathname } = useLocation()
  const { isDisplayLightUp, setIsDisplayLightUp, resetIsDisplayLightUp } = useGlobalStore()

  useEffect(() => {
    if (isDisplayLightUp !== null) {
      if (isDisplayLightUp) Bridge.handleReqUpDisplayLight()
      else {
        Bridge.handleReqDownDisplayLight()
        resetIsDisplayLightUp()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDisplayLightUp])

  useEffect(() => {
    if (isDisplayLightUp) {
      setIsDisplayLightUp(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])
}
